<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              type="password"
              v-model="currentPassword"
              label="Current Password *"
              :rules="emptyRule"
              required
            ></v-text-field>
            <v-text-field
              type="password"
              v-model="newPassword"
              label="New password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              label="Confirm password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-btn color="green" depressed dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" depressed dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Change password",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
      valid: true,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Change Password",
          disabled: false,
          to: "/changePassword"
        }
      ],
      roleTypes: null,
      selectedRoleType: null,
      currentPassword: null,
      newPassword: null,
      confirmPassword: null
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.axios
          .put(
            config.API + `PasswordChange/` + sessionStorage.loggedInUserID,
            {
              currentPassword: this.currentPassword,
              newPassword: this.newPassword,
              confirmPassword: this.confirmPassword
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Password updated successful");
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
</style>
